export default __webpack_public_path__ + "846a12caf01a940847a709ae90dff26f.ttf";